import React from 'react';
import ReactDOM from 'react-dom';

import {
  CustomAmountLoaderService,
  onClickCustomAmount,
} from '../../actions/buyCustomAmount';
import { getStore } from '../../store';
import * as loader from '../loader';
import { CustomAmountOnLanding } from './CustomAmountOnLanding';
import { unmountSectionPreloader } from './section-preloader-render';

export const renderCustomAmount = ({
  currentGroupItems,
  blockId,
  currentSection,
  currentSectionList,
}) => {
  const store = getStore();
  const {
    scripts: { merchantId, locale },
    landingServices: { customAmountService },
  } = store.getState();

  const serviceCustomAmountLoader = new CustomAmountLoaderService();
  loader.attach(serviceCustomAmountLoader);

  ReactDOM.render(
    <CustomAmountOnLanding
      merchantId={merchantId}
      locale={locale}
      item={currentGroupItems}
      blockId={blockId}
      onClickCustomAmount={onClickCustomAmount(customAmountService)}
    />,
    currentSectionList
  );
  unmountSectionPreloader(currentSection);
  loader.detach(serviceCustomAmountLoader);
};
